import React from 'react';
import { useQuery } from 'react-query';
import { useServiceClient } from 'common';
import { MyAppsEndPoints, MyAppsQueryKey } from './query-enums';

export interface IBuildHistoryData {
    buildHistory: {
        appIdVersion: string;
        appVersion: string;
        build: {
            appVersion: string;
            apps: {
                id: string;
                status: string;
                type: string;
            }[];
            date: string;
            requestedBy: string;
            version: string;
        }[] | null;
        id: string;
    }[]
}
export const useGetBuildHistoryQuery = (appBaseId: string) => {
    const { getData } = useServiceClient();
    const getBuildHistory = React.useCallback(() => getData(`${MyAppsEndPoints.GET_BUILD_HISTORY}/${appBaseId}`).then((res) => res.json()), [appBaseId, getData]);
    return useQuery<IBuildHistoryData>(MyAppsQueryKey.GET_BUILD_HISTORY, getBuildHistory);
};
